import React, { Component, useState } from 'react';
import {
	Modal,
	ModalBody,
	Button,
	Col,
	Label,
	Input,
	Row,
	InputGroup,
	InputGroupAddon,
	Dropdown,
	DropdownToggle,
	DropdownMenu,
	DropdownItem,
	FormGroup,
} from 'reactstrap';
import gift from '../assets/imgs/dashboard/gift.png';
import gift1 from '../assets/imgs/dashboard/gift1.png';
import dog from '../assets/imgs/dashboard/dog.png';
import cake from '../assets/imgs/dashboard/cake.png';
import profile from '../assets/imgs/dashboard/profile.png';
import button_logo from '../assets/imgs/dashboard/button_logo.png';
import CustomToggler from '../components/CustomToggler';
import avatar from '../assets/imgs/new/avatar.png';
import avatar_profile from '../assets/imgs/new/Avatar_Profile.png';
import bg from '../assets/imgs/new/Bg.png';
import Media from '../assets/imgs/new/Media.png';

class Timeline extends Component {
	state = {
		modals: {
			categories: true,
			createTimeline: false,
		},
		profileType: 'person',
	};
	componentDidMount() {
		let prevState = this.props.history.location.state;
		if (prevState != null) {
			if (prevState['createMemoir']) {
				let { modals } = JSON.parse(JSON.stringify(this.state));
				modals['categories'] = true;
				this.setState({
					modals,
				});
			}
		}
	}
	toggleModal = name => {
		let { modals } = JSON.parse(JSON.stringify(this.state));
		for (let modal of Object.keys(modals)) {
			if (modal != name) modals[modal] = false;
		}

		modals[name] = !modals[name];
		this.setState({
			...this.state,
			modals,
		});
	};
	render() {
		return (
			<>
				<div className='container-fluid pt-3'>
					<div className='d-flex align-items-center'>
						<h2 className='font-weight-bold text-uppercase'>
							Memoir
						</h2>
						<div className='d-flex align-items-center ml-auto'>
							<span className='mr-4'>
								<svg
									width='24'
									height='24'
									viewBox='0 0 24 24'
									fill='none'
									xmlns='http://www.w3.org/2000/svg'
								>
									<path
										d='M15.5 14H14.71L14.43 13.73C15.41 12.59 16 11.11 16 9.5C16 5.91 13.09 3 9.5 3C5.91 3 3 5.91 3 9.5C3 13.09 5.91 16 9.5 16C11.11 16 12.59 15.41 13.73 14.43L14 14.71V15.5L19 20.49L20.49 19L15.5 14ZM9.5 14C7.01 14 5 11.99 5 9.5C5 7.01 7.01 5 9.5 5C11.99 5 14 7.01 14 9.5C14 11.99 11.99 14 9.5 14Z'
										fill='black'
									/>
								</svg>
							</span>
							<span className='mr-4'>
								<svg
									width='24'
									height='24'
									viewBox='0 0 24 24'
									fill='none'
									xmlns='http://www.w3.org/2000/svg'
								>
									<path
										d='M12 22C13.1 22 14 21.1 14 20H10C10 21.1 10.9 22 12 22ZM18 16V11C18 7.93 16.37 5.36 13.5 4.68V4C13.5 3.17 12.83 2.5 12 2.5C11.17 2.5 10.5 3.17 10.5 4V4.68C7.64 5.36 6 7.92 6 11V16L4 18V19H20V18L18 16ZM16 17H8V11C8 8.52 9.51 6.5 12 6.5C14.49 6.5 16 8.52 16 11V17Z'
										fill='black'
									/>
								</svg>
							</span>
							<span className='mr-4'>
								<svg
									width='24'
									height='24'
									viewBox='0 0 24 24'
									fill='none'
									xmlns='http://www.w3.org/2000/svg'
								>
									<path
										d='M18 16.08C17.24 16.08 16.56 16.38 16.04 16.85L8.91 12.7C8.96 12.47 9 12.24 9 12C9 11.76 8.96 11.53 8.91 11.3L15.96 7.19C16.5 7.69 17.21 8 18 8C19.66 8 21 6.66 21 5C21 3.34 19.66 2 18 2C16.34 2 15 3.34 15 5C15 5.24 15.04 5.47 15.09 5.7L8.04 9.81C7.5 9.31 6.79 9 6 9C4.34 9 3 10.34 3 12C3 13.66 4.34 15 6 15C6.79 15 7.5 14.69 8.04 14.19L15.16 18.35C15.11 18.56 15.08 18.78 15.08 19C15.08 20.61 16.39 21.92 18 21.92C19.61 21.92 20.92 20.61 20.92 19C20.92 17.39 19.61 16.08 18 16.08Z'
										fill='black'
									/>
								</svg>
							</span>
							<div className='d-flex align-items-center'>
								<span className='avatar-topbar'>
									<img src={avatar} />
								</span>
								<i className='ml-2 fa fa-angle-down'></i>
							</div>
						</div>
					</div>
					<hr />
					<div className='mt-5'>
						<div
							className='memoir'
							style={{
								background: `linear-gradient(180deg, rgba(219, 195, 166, 0) 0%, #DBC3A6 65.94%),url(${bg})`,
							}}
						>
							<div
								className='avatar-update-container profile'
								style={{
									background: 'transparent',
								}}
							>
								<label for='file' className='avatar-update'>
									<img src={avatar_profile} />
								</label>
								<div className='qr-code text-center'>
									<div>
										<span className='d-block'>
											<svg
												width='26'
												height='26'
												viewBox='0 0 26 26'
												fill='none'
												xmlns='http://www.w3.org/2000/svg'
											>
												<path
													d='M0 11.5556H11.5556V0H0V11.5556ZM2.88889 2.88889H8.66667V8.66667H2.88889V2.88889Z'
													fill='black'
												/>
												<path
													d='M0 26H11.5556V14.4445H0V26ZM2.88889 17.3333H8.66667V23.1111H2.88889V17.3333Z'
													fill='black'
												/>
												<path
													d='M14.4445 0V11.5556H26V0H14.4445ZM23.1111 8.66667H17.3333V2.88889H23.1111V8.66667Z'
													fill='black'
												/>
												<path
													d='M26 23.1111H23.1111V26H26V23.1111Z'
													fill='black'
												/>
												<path
													d='M17.3333 14.4445H14.4445V17.3333H17.3333V14.4445Z'
													fill='black'
												/>
												<path
													d='M20.2223 17.3333H17.3334V20.2222H20.2223V17.3333Z'
													fill='black'
												/>
												<path
													d='M17.3333 20.2222H14.4445V23.1111H17.3333V20.2222Z'
													fill='black'
												/>
												<path
													d='M20.2223 23.1111H17.3334V26H20.2223V23.1111Z'
													fill='black'
												/>
												<path
													d='M23.1111 20.2222H20.2222V23.1111H23.1111V20.2222Z'
													fill='black'
												/>
												<path
													d='M23.1111 14.4445H20.2222V17.3333H23.1111V14.4445Z'
													fill='black'
												/>
												<path
													d='M26 17.3333H23.1111V20.2222H26V17.3333Z'
													fill='black'
												/>
											</svg>
										</span>
										<span
											className='mt-2 d-block text-uppercase'
											style={{ fontSize: 14 }}
										>
											Generate
											<br />
											QR Code
										</span>
									</div>
								</div>
								<span className='edit-icon-avatar'>
									<svg
										width='50'
										height='50'
										viewBox='0 0 50 50'
										fill='none'
										xmlns='http://www.w3.org/2000/svg'
									>
										<path
											d='M6.25 35.9375V43.75H14.0625L37.1042 20.7083L29.2917 12.8958L6.25 35.9375ZM43.1458 14.6667C43.9583 13.8542 43.9583 12.5417 43.1458 11.7292L38.2708 6.85416C37.4583 6.04166 36.1458 6.04166 35.3333 6.85416L31.5208 10.6667L39.3333 18.4792L43.1458 14.6667Z'
											fill='black'
											fill-opacity='0.25'
										/>
									</svg>
								</span>
							</div>
							<div className='text-center py-4'>
								<h3 className='font-weight-bold'>
									Alessandro del Lamborghini
								</h3>
								<div className='d-flex align-items-center mt-4 justify-content-center'>
									<h5 className='m-0 font-weight-bold'>
										7 May 1969
									</h5>
									<div className='mx-4 v-line'></div>
									<h5 className='m-0 font-weight-bold'>
										10 September 2018
									</h5>
								</div>
								<p className='container mt-5'>
									Lorem ipsum dolor sit amet, consectetur
									adipiscing elit, sed do eiusmod tempor
									incididunt ut labore et dolore magna aliqua.
									Ut enim ad minim veniam, quis nostrud
									exercitation ullamco laboris nisi ut aliquip
									ex ea commodo consequat. Duis aute irure
									dolor in reprehenderit in voluptate velit
									esse cillum dolore eu fugiat nulla pariatur.
									Excepteur sint occaecat cupidatat non
									proident, sunt in culpa qui officia deserunt
									mollit anim id est laborum.
								</p>
							</div>
							<div className='mt-2 pb-4 d-flex flex-wrap justify-content-center'>
								<Button className='btn-outline mr-3 align-items-center d-flex dashboard-btn'>
									<span className='mr-2'>
										<svg
											width='18'
											height='24'
											viewBox='0 0 18 24'
											fill='none'
											xmlns='http://www.w3.org/2000/svg'
										>
											<path
												d='M9 18.2857C10.2375 18.2857 11.25 17.2571 11.25 16C11.25 14.7429 10.2375 13.7143 9 13.7143C7.7625 13.7143 6.75 14.7429 6.75 16C6.75 17.2571 7.7625 18.2857 9 18.2857ZM15.75 8H14.625V5.71429C14.625 2.56 12.105 0 9 0C5.895 0 3.375 2.56 3.375 5.71429H5.5125C5.5125 3.76 7.07625 2.17143 9 2.17143C10.9237 2.17143 12.4875 3.76 12.4875 5.71429V8H2.25C1.0125 8 0 9.02857 0 10.2857V21.7143C0 22.9714 1.0125 24 2.25 24H15.75C16.9875 24 18 22.9714 18 21.7143V10.2857C18 9.02857 16.9875 8 15.75 8ZM15.75 21.7143H2.25V10.2857H15.75V21.7143Z'
												fill='black'
											/>
										</svg>
									</span>
									Preview Public View
								</Button>
								<Button className='btn-outline mr-3 dashboard-btn'>
									<span className='mr-2'>
										<svg
											width='18'
											height='24'
											viewBox='0 0 18 24'
											fill='none'
											xmlns='http://www.w3.org/2000/svg'
										>
											<path
												d='M15.75 8H14.625V5.71429C14.625 2.56 12.105 0 9 0C5.895 0 3.375 2.56 3.375 5.71429V8H2.25C1.0125 8 0 9.02857 0 10.2857V21.7143C0 22.9714 1.0125 24 2.25 24H15.75C16.9875 24 18 22.9714 18 21.7143V10.2857C18 9.02857 16.9875 8 15.75 8ZM9 18.2857C7.7625 18.2857 6.75 17.2571 6.75 16C6.75 14.7429 7.7625 13.7143 9 13.7143C10.2375 13.7143 11.25 14.7429 11.25 16C11.25 17.2571 10.2375 18.2857 9 18.2857ZM12.4875 8H5.5125V5.71429C5.5125 3.76 7.07625 2.17143 9 2.17143C10.9237 2.17143 12.4875 3.76 12.4875 5.71429V8Z'
												fill='black'
											/>
										</svg>
									</span>
									Private Timeline
								</Button>
								<Button className='btn-outline mr-3 dashboard-btn'>
									<span className='mr-2'>
										<svg
											width='24'
											height='24'
											viewBox='0 0 24 24'
											fill='none'
											xmlns='http://www.w3.org/2000/svg'
										>
											<path
												d='M21.5033 19.7915L20.4315 6.28603C20.3647 5.41594 19.6288 4.73433 18.7562 4.73433H16.6392V4.63917C16.6392 2.08111 14.5581 0 12 0C9.44196 0 7.36085 2.08111 7.36085 4.63917V4.73433H5.24388C4.37121 4.73433 3.63532 5.41589 3.56876 6.2842L2.49663 19.7933C2.41366 20.8749 2.7889 21.9518 3.52605 22.7476C4.26321 23.5435 5.30819 24 6.39302 24H17.607C18.6918 24 19.7368 23.5435 20.474 22.7476C21.2111 21.9517 21.5863 20.8749 21.5033 19.7915ZM8.76663 4.63917C8.76663 2.85628 10.2172 1.40578 12 1.40578C13.7829 1.40578 15.2334 2.85633 15.2334 4.63917V4.73433H8.76663V4.63917ZM19.4426 21.7924C18.9636 22.3095 18.3118 22.5942 17.607 22.5942H6.39307C5.68826 22.5942 5.03641 22.3095 4.55744 21.7924C4.07852 21.2753 3.84443 20.6035 3.89824 19.9027L4.97027 6.39352C4.98115 6.25139 5.10133 6.14011 5.24388 6.14011H7.36085V7.87144C7.36085 8.25961 7.67557 8.57433 8.06374 8.57433C8.45191 8.57433 8.76663 8.25961 8.76663 7.87144V6.14011H15.2334V7.87144C15.2334 8.25961 15.5481 8.57433 15.9363 8.57433C16.3245 8.57433 16.6392 8.25961 16.6392 7.87144V6.14011H18.7562C18.8987 6.14011 19.0189 6.25144 19.03 6.39539L20.1018 19.9008C20.1557 20.6035 19.9215 21.2753 19.4426 21.7924Z'
												fill='black'
											/>
											<path
												d='M15.1667 11.9196C14.8923 11.6451 14.4472 11.6451 14.1728 11.9196L11.0342 15.0581L9.82735 13.8513C9.55289 13.5768 9.10782 13.5768 8.83332 13.8513C8.55882 14.1258 8.55882 14.5708 8.83332 14.8453L10.5372 16.5492C10.6744 16.6864 10.8543 16.7551 11.0341 16.7551C11.214 16.7551 11.3939 16.6865 11.5311 16.5492L15.1666 12.9136C15.4412 12.6391 15.4412 12.1941 15.1667 11.9196Z'
												fill='black'
											/>
										</svg>
									</span>
									Order QR Code
								</Button>
								<Button className='btn-outline mr-3 dashboard-btn'>
									<span className='mr-2'>
										<svg
											width='38'
											height='24'
											viewBox='0 0 38 24'
											fill='none'
											xmlns='http://www.w3.org/2000/svg'
										>
											<path
												d='M25.9091 10.2857C28.7764 10.2857 31.0736 7.98857 31.0736 5.14286C31.0736 2.29714 28.7764 0 25.9091 0C23.0418 0 20.7273 2.29714 20.7273 5.14286C20.7273 7.98857 23.0418 10.2857 25.9091 10.2857ZM12.0909 10.2857C14.9582 10.2857 17.2555 7.98857 17.2555 5.14286C17.2555 2.29714 14.9582 0 12.0909 0C9.22364 0 6.90909 2.29714 6.90909 5.14286C6.90909 7.98857 9.22364 10.2857 12.0909 10.2857ZM12.0909 13.7143C8.06636 13.7143 0 15.72 0 19.7143V24H24.1818V19.7143C24.1818 15.72 16.1155 13.7143 12.0909 13.7143ZM25.9091 13.7143C25.4082 13.7143 24.8382 13.7486 24.2336 13.8C26.2373 15.24 27.6364 17.1771 27.6364 19.7143V24H38V19.7143C38 15.72 29.9336 13.7143 25.9091 13.7143Z'
												fill='black'
											/>
										</svg>
									</span>
									Invite Collaborator
								</Button>
							</div>
						</div>
						<div className='filterby mt-4 d-none'>
							<h4 className='font-weight-bold'>Filter By</h4>
							<Row className='mt-5'>
								<Col md='3'>
									<Label>Selected Date</Label>
									<Input type='date'></Input>
								</Col>
								<Col md='4'>
									<Label>Selected Milestone</Label>
									<Input type='select'></Input>
								</Col>
							</Row>
							<Row className='mt-4'>
								<Col md='4'>
									<Label>Filter by</Label>
									<Input type='select'></Input>
								</Col>
								<Col md='4'>
									<Label>Collaborator</Label>
									<Input type='select'></Input>
								</Col>
							</Row>
						</div>
						<div className='downloaded_media mt-4'>
							<div className='d-block d-md-flex align-items-center'>
								<h3 className='font-weight-bold'>
									Downloaded Media
								</h3>
								<div className='ml-auto d-block d-md-flex align-items-end'>
									<FormGroup className='m-0 mr-0 mr-md-2 w-100'>
										<Label className='m-0'>
											Collaborator
										</Label>
										<Input type='select'>
											<option hidden selected>
												All
											</option>
										</Input>
									</FormGroup>
									<div className='searchbar w-100 mt-3 mt-md-0'>
										<InputGroup>
											<InputGroupAddon addonType='prepend'>
												<div
													className='d-flex align-items-center justify-content-center'
													style={{
														backgroundColor:
															'#E5E5E5',
														width: 50,
														border: '1px solid var(--fieldBorderColor)',
														borderTopLeftRadius:
															'.25rem',
														borderBottomLeftRadius:
															'.25rem',
													}}
												>
													<i className='fa fa-search'></i>
												</div>
											</InputGroupAddon>
											<Input placeholder='Search'></Input>
										</InputGroup>
									</div>
								</div>
							</div>
							<div className='mt-4 d-flex align-items-center'>
								<div className='d-flex align-items-center'>
									<div className='avatar-topbar'>
										<img src={avatar} />
									</div>
									<span className='ml-2 font-weight-bold'>
										My Media
									</span>
								</div>
								<Button
									className='btn-outline ml-auto px-3 dashboard-btn'
									style={{ minWidth: 'auto' }}
								>
									+ Add Memoria
								</Button>
							</div>
							<Row className='mt-5'>
								{new Array(5).fill(1).map(() => (
									<Col md='6' lg='4'>
										<LC_Media />
									</Col>
								))}
							</Row>
							<hr />
							<div className='mt-4 d-flex align-items-center'>
								<div className='d-flex align-items-center'>
									<div className='avatar-topbar'>
										<img src={avatar} />
									</div>
									<span className='ml-2 font-weight-bold'>
										Collaborator Name’s Media
									</span>
								</div>
							</div>
							<Row className='mt-4'>
								{new Array(1).fill(1).map(() => (
									<Col md='6' lg='4'>
										<LC_Media />
									</Col>
								))}
							</Row>
							<hr />
							<div className='mt-4 d-flex align-items-center'>
								<div className='d-flex align-items-center'>
									<div className='avatar-topbar'>
										<img src={avatar} />
									</div>
									<span className='ml-2 font-weight-bold'>
										Collaborator Name’s Media
									</span>
								</div>
							</div>
							<Row className='mt-4'>
								{new Array(2).fill(1).map(() => (
									<Col md='6' lg='4'>
										<LC_Media />
									</Col>
								))}
							</Row>
						</div>
					</div>
				</div>
				<Modal
					isOpen={this.state.modals.categories}
					size='xl'
					centered
					className='custom-modal'
					toggle={e => this.toggleModal('categories')}
				>
					<ModalBody>
						<div className='d-flex'>
							<div
								className='custom-close-icon ml-auto'
								onClick={e => this.toggleModal('categories')}
							>
								<i className='fa fa-times'></i>
							</div>
						</div>
						<div className='modal-content-wrapper pt-0'>
							<div className='image-update size-sm'>
								<img src={profile} style={{ width: '100%' }} />
							</div>
							<h4 className='text-center mt-3 font-weight-bold'>
								Choose from the categories Below
							</h4>
							<div className='row'>
								<div className='col-md-6 col-lg-4 col-xl-3 mt-5 text-center'>
									<div className='category-card'>
										<div className='card-body text-center d-flex flex-column'>
											<img
												src={gift}
												style={{
													height: 70,
													margin: '0 auto',
												}}
											/>
											<span className='mt-3'>
												Anniversaries
											</span>
										</div>
									</div>
								</div>
								<div className='col-md-6 col-lg-4 col-xl-3 mt-5 text-center'>
									<div className='category-card'>
										<div className='card-body text-center d-flex flex-column'>
											<img
												src={cake}
												style={{
													height: 70,
													margin: '0 auto',
												}}
											/>
											<span className='mt-3'>
												Birthday
											</span>
										</div>
									</div>
								</div>
								<div className='col-md-6 col-lg-4 col-xl-3 mt-5 text-center'>
									<div className='category-card'>
										<div className='card-body text-center d-flex flex-column'>
											<img
												src={dog}
												style={{
													height: 70,
													margin: '0 auto',
												}}
											/>
											<span className='mt-3'>Pet</span>
										</div>
									</div>
								</div>
								<div className='col-md-6 col-lg-4 col-xl-3 mt-5 text-center'>
									<div className='category-card'>
										<div className='card-body text-center d-flex flex-column'>
											<img
												src={gift1}
												style={{
													height: 70,
													margin: '0 auto',
												}}
											/>
											<span className='mt-3'>
												Someone Else
											</span>
										</div>
									</div>
								</div>
								<div className='col-md-6 col-lg-4 col-xl-3 mt-5 text-center'>
									<div className='category-card'>
										<div className='card-body text-center d-flex flex-column'>
											<img
												src={dog}
												style={{
													height: 70,
													margin: '0 auto',
												}}
											/>
											<span className='mt-3'>Pet</span>
										</div>
									</div>
								</div>
								<div className='col-md-6 col-lg-4 col-xl-3 mt-5 text-center'>
									<div className='category-card'>
										<div className='card-body text-center d-flex flex-column'>
											<img
												src={gift}
												style={{
													height: 70,
													margin: '0 auto',
												}}
											/>
											<span className='mt-3'>
												Anniversaries
											</span>
										</div>
									</div>
								</div>
								<div className='col-md-6 col-lg-4 col-xl-3 mt-5 text-center'>
									<div className='category-card'>
										<div className='card-body text-center d-flex flex-column'>
											<img
												src={gift1}
												style={{
													height: 70,
													margin: '0 auto',
												}}
											/>
											<span className='mt-3'>Event</span>
										</div>
									</div>
								</div>
								<div className='col-md-6 col-lg-4 col-xl-3 mt-5 text-center'>
									<div className='category-card'>
										<div className='card-body text-center d-flex flex-column'>
											<img
												src={cake}
												style={{
													height: 70,
													margin: '0 auto',
												}}
											/>
											<span className='mt-3'>Myself</span>
										</div>
									</div>
								</div>
								<div className='col-md-6 col-lg-4 col-xl-3 mt-5 text-center'>
									<div className='category-card'>
										<div className='card-body text-center d-flex flex-column'>
											<img
												src={dog}
												style={{
													height: 70,
													margin: '0 auto',
												}}
											/>
											<span className='mt-3'>Pet</span>
										</div>
									</div>
								</div>
								<div className='col-md-6 col-lg-4 col-xl-3 mt-5 text-center'>
									<div className='category-card'>
										<div className='card-body text-center d-flex flex-column'>
											<img
												src={gift}
												style={{
													height: 70,
													margin: '0 auto',
												}}
											/>
											<span className='mt-3'>
												Anniversaries
											</span>
										</div>
									</div>
								</div>
								<div className='col-md-6 col-lg-4 col-xl-3 mt-5 text-center'>
									<div className='category-card'>
										<div className='card-body text-center d-flex flex-column'>
											<img
												src={gift1}
												style={{
													height: 70,
													margin: '0 auto',
												}}
											/>
											<span className='mt-3'>Event</span>
										</div>
									</div>
								</div>
								<div className='col-md-6 col-lg-4 col-xl-3 mt-5 text-center'>
									<div className='category-card'>
										<div className='card-body text-center d-flex flex-column'>
											<img
												src={cake}
												style={{
													height: 70,
													margin: '0 auto',
												}}
											/>
											<span className='mt-3'>Myself</span>
										</div>
									</div>
								</div>
							</div>

							<button
								className='btn btn-primary d-block w-100 mt-3 position-relative'
								style={{ fontSize: 32, minHeight: 60 }}
								onClick={e => {
									e.preventDefault();
									this.toggleModal('createTimeline');
								}}
							>
								<img
									src={button_logo}
									className='position-absolute'
									style={{
										height: 40,
										left: 70,
										top: '50%',
										transform: 'translateY(-50%)',
									}}
								/>
								Creating a Memoir
							</button>
						</div>
					</ModalBody>
				</Modal>
				<Modal
					isOpen={this.state.modals.createTimeline}
					size='lg'
					centered
					className='custom-modal'
					toggle={e => this.toggleModal('createTimeline')}
				>
					<ModalBody>
						<div className='d-flex'>
							<div
								className='custom-close-icon ml-auto'
								onClick={e =>
									this.toggleModal('createTimeline')
								}
							>
								<i className='fa fa-times'></i>
							</div>
						</div>
						<div className='modal-content-wrapper pt-0'>
							<h4 className='mt-3 font-weight-bold'>
								Create a Memoir
							</h4>
							<span className='d-block timeline-for mt-4'>
								<label className='text-muted'>
									What is timeline for?
								</label>
								<div className='d-flex radio-group'>
									<div className='d-flex radio align-items-center'>
										<input
											type='radio'
											name='profileType'
											onClick={e =>
												this.setState({
													profileType: 'person',
												})
											}
											checked={
												this.state.profileType ==
												'person'
											}
											id='person'
										/>
										<label className='ml-2' for='person'>
											A Person
										</label>
									</div>
									<div className='ml-5 d-flex radio align-items-center'>
										<input
											type='radio'
											name='profileType'
											onClick={e =>
												this.setState({
													profileType: 'else',
												})
											}
											checked={
												this.state.profileType == 'else'
											}
											id='else'
										/>
										<label className='ml-2' for='else'>
											Something else
										</label>
									</div>
								</div>
							</span>
							<div
								className={`${
									this.state.profileType == 'person'
										? 'd-block'
										: 'd-none'
								}`}
							>
								<label className='d-flex mt-3 text-muted'>
									Name
								</label>
								<div className='row'>
									<div className='col-md-6'>
										<input
											type='text'
											className='form-control'
											placeholder='First name'
										/>
									</div>
									<div className='col-md-6'>
										<input
											type='text'
											className='form-control'
											placeholder='Last name'
										/>
									</div>
								</div>
								<label className='d-flex mt-3 text-muted'>
									Add an introduction
								</label>
								<textarea
									className='form-control'
									rows='4'
									placeholder='This Timeline was created to help collect our memories in a single place online'
								/>
								<label className='d-flex mt-3 text-muted'>
									What's your relationship to them?
								</label>
								<select className='form-control'>
									<option selected hidden>
										Select
									</option>
								</select>
								<label className='d-flex mt-3 text-muted'>
									Date of Birth?
								</label>
								<div className='row align-items-center'>
									<div className='col-md-6'>
										<input
											type='date'
											className='form-control'
										/>
									</div>
									<div className='col-md-6 '>
										<span>
											- Present{' '}
											<i className='ml-2 fa fa-pencil'></i>
										</span>
									</div>
								</div>
								<label className='d-flex mt-3 text-muted'>
									What's their hometown?
								</label>
								<input
									type='text'
									className='form-control'
									placeholder='City'
								></input>
								<label className='d-flex mt-3 text-muted'>
									Default Timeline display options
								</label>
								<select className='form-control'>
									<option selected hidden>
										Newest to oldest
									</option>
								</select>
							</div>
							<div
								className={`${
									this.state.profileType == 'else'
										? 'd-block'
										: 'd-none'
								}`}
							>
								<label className='d-flex mt-3 text-muted'>
									Choose a Catrgory
								</label>
								<select className='form-control'>
									<option selected hidden>
										Pet
									</option>
								</select>
								<label className='d-flex mt-3 text-muted'>
									Name the Timeline
								</label>
								<input
									className='form-control'
									placeholder='Name'
								/>
								<label className='d-flex mt-3 text-muted'>
									Add an introduction
								</label>
								<textarea
									className='form-control'
									rows='4'
									placeholder='This Timeline was created to help collect our memories in a single place online'
								/>
								<div className='row mt-3'>
									<div className='col-md-8'>
										<label>Start date</label>
										<div className='row'>
											<div className='col'>
												<input
													type='text'
													className='form-control'
													placeholder='yyyy'
												/>
											</div>
											<div className='col'>
												<input
													type='text'
													className='form-control'
													placeholder='mm'
												/>
											</div>
											<div className='col'>
												<input
													type='text'
													className='form-control'
													placeholder='dd'
												/>
											</div>
										</div>
									</div>
								</div>
								<div className='row mt-3'>
									<div className='col-md-8'>
										<label>End date</label>
										<div className='row'>
											<div className='col'>
												<input
													type='text'
													className='form-control'
													placeholder='yyyy'
												/>
											</div>
											<div className='col'>
												<input
													type='text'
													className='form-control'
													placeholder='mm'
												/>
											</div>
											<div className='col'>
												<input
													type='text'
													className='form-control'
													placeholder='dd'
												/>
											</div>
										</div>
									</div>
								</div>

								<label className='d-flex mt-3 text-muted'>
									Add a Location
								</label>
								<input
									type='text'
									className='form-control'
									placeholder='City'
								></input>
								<label className='d-flex mt-3 text-muted'>
									Default Timeline display options
								</label>
								<select className='form-control'>
									<option selected hidden>
										Newest to oldest
									</option>
								</select>
							</div>

							<label className='d-flex mt-4'>
								Privacy settings
							</label>

							<hr />
							<div className='d-flex'>
								<p className='mt-0 text-muted'>
									Your privacy is extremely important to us.
									You can change these settings at anytime
								</p>
								<span>No/Yes</span>
							</div>
							<div className='settings'>
								<div className='d-flex align-items-center'>
									<p>Timeline is public</p>
									<span className='ml-auto'>
										<CustomToggler />
									</span>
								</div>
								<div className='d-flex align-items-center'>
									<p>Allow Comments</p>
									<span className='ml-auto'>
										<CustomToggler />
									</span>
								</div>
								<div className='d-flex align-items-center'>
									<p>Hide from search engines</p>
									<span className='ml-auto'>
										<CustomToggler />
									</span>
								</div>
								<div className='d-flex align-items-center'>
									<p>
										Add my Family and Friends as
										Contributers
									</p>
									<span className='ml-auto'>
										<CustomToggler />
									</span>
								</div>
								<div className='d-flex align-items-center'>
									<p>Only contributers can add memories</p>
									<span className='ml-auto'>
										<CustomToggler />
									</span>
								</div>
							</div>
							<div className='row mt-3'>
								<div className='col-md-6'>
									<button
										className='btn btn-block w-100'
										style={{ backgroundColor: '#566edc' }}
									>
										<i className='fa fa-plus mr-3'></i>
										Create a Memoir
									</button>
								</div>
								<div className='col-md-6 mt-3 mt-md-0'>
									<button
										className='btn btn-block w-100'
										style={{
											border: '1.5px solid #566edc',
											color: '#566edc',
										}}
										onClick={e =>
											this.toggleModal('createTimeline')
										}
									>
										Cancel
									</button>
								</div>
							</div>
						</div>
					</ModalBody>
				</Modal>
			</>
		);
	}
}

const LC_Media = props => {
	let [edit, setEdit] = useState(false);
	const [dropdownOpen, setDropdownOpen] = useState(false);

	const toggle = () => setDropdownOpen(prevState => !prevState);
	return (
		<div className='lc_media'>
			<div className='w-100'>
				<img src={Media} className='media_img' />
			</div>
			<p style={{ fontSize: 18 }} className='mt-3 font-weight-bold'>
				Graduation 84th
			</p>
			<p style={{ fontSize: 18 }}>
				Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
				eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
				enim ad minim veniam, quis nostrud exercitation ullamco laboris
				nisi ut aliquip ex ea commodo consequat.
			</p>
			<div className='d-flex'>
				{edit ? (
					<>
						<input style={{ width: 150 }} type='date' />
						<Dropdown
							className='ml-2'
							isOpen={dropdownOpen}
							toggle={toggle}
						>
							<DropdownToggle caret>
								Graduation 84th
							</DropdownToggle>
							<DropdownMenu>
								<DropdownItem>Graduation 84th</DropdownItem>
								<DropdownItem>Graduation 84th</DropdownItem>
								<DropdownItem>Graduation 84th</DropdownItem>
								<DropdownItem>Graduation 84th</DropdownItem>
							</DropdownMenu>
						</Dropdown>
					</>
				) : (
					<p style={{ fontSize: 18 }} className='font-weight-bold'>
						5-15-1984
					</p>
				)}
				<span className='ml-auto text-muted'>
					<i
						className={`fa fa-pencil pointer mr-2 ${
							edit ? 'text-danger' : ''
						}`}
						onClick={e => setEdit(!edit)}
					></i>
					<i className='fa fa-trash'></i>
				</span>
			</div>
		</div>
	);
};

export default Timeline;
